
"t";
import React, { useState } from "react";
import { Grid, Box, Typography, useMediaQuery } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import "../style/components.css"; // Ensure styles are added properly


const MainContainer = styled(Box)(({ theme }) => ({
    background: "#000",
    display: "flex",
    flexDirection: "column",
    padding: "60px 24px",
    position: "relative",
    overflow: "hidden",
    width: "100%",
    margin: "0 auto",

    "&::after": {
        content: '""',
        position: "absolute",
        width: "90%",
        height: "90%",
        left: "70%",
        top: "0",
        transform: "translateX(-100%), translateY(-50%)",
        background:
            "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
        filter: "blur(100px)",
        //backdropFilter: "blur(500px)",
        zIndex: 0,
    },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
    width: "100%", // Set to 95% width
    maxWidth: "1200px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
        width: "97%",
    },
}));




const SliderViewSection = ({ title, subTitle, data }) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    // Function to handle previous/next slide
    const handleSlideChange = (direction) => {
        setActiveIndex((prevIndex) =>
            direction === "prev"
                ? prevIndex === 0
                    ? data.length - 1
                    : prevIndex - 1
                : prevIndex === data.length - 1
                    ? 0
                    : prevIndex + 1
        );
    };

    return (
        <MainContainer>
            <ContentContainer>
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    alignItems="center"
                    textAlign="center"
                    sx={{ width: { xs: "100%", md: "80%" } }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontSize: { xs: "24px", sm: "32px", md: "40px" },
                            fontWeight: 700,
                            mb: 3,
                            textAlign: "center",
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        sx={{
                            color: "#8C8CC2",
                            fontSize: { xs: "14px", md: "18px" },
                            lineHeight: 1.8,
                            textAlign: "center",
                            marginTop: 2,
                            marginBottom: 10,
                        }}
                    >
                        {subTitle}
                    </Typography>
                </Box>

                <Box className="slidMedia-section">
                    <Grid container spacing={2} alignItems="flex-start" justifyContent="center">
                        {/* Left Section: Text Content */}
                        <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: { md: "flex-start" },
                                textAlign: { md: "left" },
                            }}
                        >
                            <Typography variant="h4" fontWeight="bold" color="white">
                                {data[activeIndex]?.title}
                            </Typography>
                            <Typography variant="body1" sx={{ mt: 6, color: "#8C8CC2" }}>
                                {data[activeIndex]?.subtitle ? data[activeIndex]?.subtitle : data[activeIndex]?.para}
                            </Typography>
                            <Box component="ul" sx={{ mt: 4, listStyle: "none", padding: 0 }}>
                                {data[activeIndex]?.lists && (
                                        data[activeIndex]?.lists.map((item, idx) => (
                                            <Box
                                                component="li"
                                                key={idx}
                                                sx={{ display: "flex", alignItems: "center", color: "#8C8CC2" }}
                                            >
                                                <Box component="span" sx={{ fontSize: "10px", color: "#8C8CC2", mr: 1 }}>
                                                    ●
                                                </Box>
                                                {item}
                                            </Box>
                                        ))
                                )}                                
                            </Box>
                        </Grid>

                        {/* Right Section: Media View */}
                        <Grid item xs={12} md={6}>
                            <Box
                                sx={{
                                    width: "100%",  // Ensures the Box takes full width
                                    display: "flex",
                                    justifyContent: "center",
                                    p:{xs:0 ,md:2}
                                }}
                            >
                                <Box
                                    component="img"
                                    src={data[activeIndex]?.mediaUrl}
                                    alt="img"
                                    sx={{
                                        width: { xs: "90%", sm: "80%", md: "100%" }, // Responsive width
                                        height: "auto",  // Maintains aspect ratio
                                        maxHeight: "540px",
                                        borderRadius: 3,
                                        display: "block",
                                    }}
                                />
                            </Box>
                        </Grid>


                    </Grid>

                </Box>
                {/* Buttons */}
                <Box
                    sx={{
                        padding: "4px", // Add some padding
                        position: { xs: "relative", md: "absolute" },
                        left: !isMobile && "35px",
                        bottom: { md: "0px", lg: "20px" },
                        display: "flex",
                        gap: 4,
                        mt: isMobile && 3
                    }}
                >
                    {/* Previous Button */}
                    <button onClick={() => handleSlideChange("prev")} className="circular-btn" style={{cursor: 'pointer'}}>
                        &lt;
                    </button>

                    {/* Next Button */}
                    <button onClick={() => handleSlideChange("next")} className="circular-btn" style={{cursor: 'pointer'}}>
                        &gt;
                    </button>
                </Box>


            </ContentContainer>
        </MainContainer>
    );
};

export default SliderViewSection;






